/**
 *  Allows to call a function on terminateSCO.
 *  It's used in course.js.jsp
 *  Following actions are used at the moment:
 *  - TTCourseAPI.startNextELearning
 *  - TTCourseAPI.startPreviousELearning
 *  - TTCourseAPI.startNextAssessment
 *  - TTCourseAPI.startPreviousAssessment
 *  - TTCourseAPI.startAssignedELearning
 *  - TTCourseAPI.startAssignedAssessment
 *
 * @returns {{
 *      hasAction: (function(): boolean),
 *      setAction: setAction, clearAction:
 *      clearAction, callAction: (function(): *)
 * }}
 */
export function CourseActionManager(){
    let m_fAction = null,
        m_objParam = null;

    function clearAction() {
        m_fAction = null;
        m_objParam = null;
    }

    // revealing public api
    return {
        setAction: function (fAction, objParam) {
            if (fAction === null) {
                clearAction();
                return;
            }

            m_fAction = fAction;
            m_objParam = objParam;
        },

        hasAction: function () {
            return m_fAction !== null;
        },

        callAction: function () {
            if( m_fAction === null ) {
                clearAction();
                return false;
            }

            return m_fAction(m_objParam);
        },

        clearAction: clearAction
    };
}
